import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "src/environments/environment"
import { VdkMbrads } from "../models"

@Injectable({
    providedIn: "root",
})
export class VdkCardService {
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.generateNewVDK;

    constructor(private http: HttpClient) {}

    generate(generateVdk: VdkMbrads): Observable<string> {
        return this.http.post<string>(this._apiUrl, generateVdk);
    }
}
